/* src/app/views/auth/components/auth/forgot-password/forgot-password.component.scss */
/*# sourceMappingURL=forgot-password.component.css.map */
